export default "__VITE_ASSET__Hrld3kbB__"